import { FC } from 'react';

interface iElementProps {
  attributes: any;
  element: any;
}
const Element: FC<iElementProps> = ({ attributes, children, element }) => {
  return <p {...attributes}>{children}</p>;
};

export default Element;
